// extracted by mini-css-extract-plugin
module.exports = {"legend":"UnitOfMeasurementLegend_legend__1DE7j","disabled":"UnitOfMeasurementLegend_disabled__3P0nt"};